// extracted by mini-css-extract-plugin
module.exports = {"link":"KWp7mTY1","text":"z9R3TR4I","icon":"__3tvxMDxL"};